<template>
  <div class="user-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('user.title') }}</h2>
    </div>

    <CrudTable
      :columns="fields"
      :data-sources="users"
      :loader="isLoading"
      list-url="/admin/users"
    >
      <!-- Name Column -->
      <template #cell(full_name)="data">
        <div class="d-flex align-items-center">
          <div class="avatar mr-3">
            {{ getInitials(data.item.full_name) }}
          </div>
          <div>
            <div class="font-weight-bold">{{ data.item.full_name || 'N/A' }}</div>
            <div class="text-muted small">{{ data.item.email || 'N/A' }}</div>
          </div>
        </div>
      </template>

      <!-- Role Column -->
      <template #cell(roles)="data">
        <div>
          {{ data.item.roles || 'N/A' }}
        </div>
      </template>

      <!-- Status Column -->
      <template #cell(invitation_status)="data">
        <div>
          {{ data.item.invitation_status || 'N/A' }}
        </div>
      </template>

      <!-- Actions Column -->
      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <!-- <b-button
            variant="outline-primary"
            size="sm"
            @click="editUser(data.item)"
          >
            <i class="fas fa-edit"></i>
          </b-button> -->
          <b-button
            variant="outline-danger"
            size="sm"
            @click="confirmDelete(data.item)"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>

    <!-- Delete Confirmation Modal -->
    <b-modal
      v-model="showDeleteModal"
      :title="$t('user.delete_modal_title')"
      @ok="handleDelete"
      ok-variant="danger"
    >
      {{ $t('user.delete_modal_message') }}
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: 'UserList',
  components: {
    CrudTable
  },

  data() {
    return {
      users: [],
      isLoading: false,
      showDeleteModal: false,
      selectedUser: null,
      currentPage: 1,
      perPage: 10,
      sortBy: 'created_at',
      sortDesc: true,

      filters: {
        search: '',
        role: null,
        status: null
      },
      fields: [
        { key: 'full_name', label: this.$t('user.table_header_user'), sortable: true, sortDirection: 'asc' },
        { key: 'roles', label: this.$t('user.table_header_role'), sortable: true, sortDirection: 'asc' },
        { key: 'phone', label: this.$t('user.table_header_phone'), sortable: true, sortDirection: 'asc' },
        { key: 'invitation_status', label: this.$t('user.table_header_status'), sortable: true, sortDirection: 'asc' },
        { key: 'created_at', label: this.$t('user.table_header_created_at'), sortable: true, sortDirection: 'asc' },
        { key: 'actions', label: this.$t('user.table_header_actions'), sortable: false }
      ],
      roleOptions: [],
      statusOptions: [
        { value: null, text: this.$t('user.status_all') },
        { value: 'active', text: this.$t('user.status_active') },
        { value: 'inactive', text: this.$t('user.status_inactive') }
      ],

    }
  },
  async created() {
    await this.fetchRoles();
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.label
      };
    },
    getInitials(name) {
      if (!name) return '';
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase();
    },
    async fetchRoles() {
      try {
          const response = await request({
              method: "get",
              url:'dropdowns/roles'});

        if (response.status === 200) {
          this.roleOptions = response.data.map(role => ({
            id: role.id,
            label: role.label
          }));
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
        this.roleOptions = [];
      }
    },
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
    },
    createUser() {
      this.$router.push('/users/create');
    },
    // editUser(user) {
    //   this.$router.push(`/users/${user.id}/edit`);
    // },
    confirmDelete(user) {
      this.selectedUser = user;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      if (!this.selectedUser) return;

      try {
        await request({
          method: 'delete',
          url: `/admin/users/${this.selectedUser.id}`
        });
        this.$bvToast.toast(this.$t('user.delete_success_message'), {
          title: this.$t('user.delete_success_title'),
          variant: 'success'
        });
        setTimeout(() => {
          this.$router.go(0);
        }, 1000);
      } catch (error) {
        this.$bvToast.toast(this.$t('user.delete_failed_message'), {
          title: this.$t('user.delete_failed_title'),
          variant: 'danger'
        });
      } finally {
        this.showDeleteModal = false;
        this.selectedUser = null;
      }
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
